export default {
  admin: {
    admin: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    project: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    resources: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    portfolio: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    user: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    organization: {
      'read:any': ['*'],
      'update:any': ['*']
    },
    integrations: {
      'read:any': ['*']
    },
    billing: {
      'read:any': ['*']
    }
  },
  owner: {
    project: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    resources: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    portfolio: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    user: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    organization: {
      'read:any': ['*'],
      'update:any': ['*']
    },
    integrations: {
      'read:any': ['*']
    },
    billing: {
      'read:any': ['*']
    }
  },
  member: {
    project: {
      'read:any': ['*'],
      'update:own': ['*']
    },
    user: {
      'read:any': ['*'],
      'update:own': ['*']
    },
    portfolio: {
      'read:any': ['*'],
      'update:any': ['*']
    }
  },

  /** Plans */
  full: {
    project: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    portfolio: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    resources: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    user: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    organization: {
      'read:any': ['*'],
      'update:any': ['*']
    },
    integrations: {
      'read:any': ['*']
    },
    billing: {
      'read:any': ['*']
    }
  },

  beta: {
    project: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    user: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    resources: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    portfolio: {
      'create:any': ['*'],
      'read:any': ['*'],
      'update:any': ['*'],
      'delete:any': ['*']
    },
    organization: {
      'read:any': ['*'],
      'update:any': ['*']
    }
  }
}
